import React, { useState, useEffect } from 'react'
import { Navigate, useNavigate,useParams, useLocation } from 'react-router-dom';
import Facebook from '../components/Facebook';
import Google from '../Google';
import {forgotPassword} from '../config/Variables';
import {baseurl} from '../config/Settings';
import Header from '../partials/Header';

function CheckEmail() {
  var element = document.getElementById("header-react");
  if(element){
  element.classList.add("hide");
  }
  //const Login=() =>{
    const [email, setEmail] = useState(useParams().email);
  const [messagelog, setMessagelog] = useState("");
  let location = useLocation();
  //const [password, setPassword] = useState();
  //const device_name = 'nokia';

  // const history = useNavigate();
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem('user-info')) {
      // history("/add");
      //  navigate('/sample');
      return <Navigate to="/personalize" />
     
    }

  }, []);
  if (localStorage.getItem('user-info')) {
    return <Navigate to="/personalize" />
  }
  const handleCheckChange =(evnt)=>{
    if(evnt==='successsfirstfacebook'){
      console.log(evnt);
      navigate('/personalize');
    }
      if(evnt==='successssecondfacebook'){
      window.location.href = baseurl; 
      }

    }

    
  async function login() {
    
    if(email==""){
      setMessagelog('Please add the react Before Submit');
    }else{
      const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if(!email || regex.test(email) === false){
              setMessagelog("البريد الإلكتروني غير صحيح"); 
            return false;
        }


    let item = { email };
    let result = await fetch(forgotPassword, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Accept": 'application/json'
      },
      body: JSON.stringify(item)
    });

    result = await result.json();
    if (result.message.code == '200') {
      navigate('/login/'+email);
      setMessagelog(result.message.message );
    }else{
      setMessagelog(result.message.message );
    }
  }
  // return <Navigate to="/register" state={{ from: location }} replace />;
    //   localStorage.setItem("user-info", JSON.stringify(result));
    //history('/add');
    //JSON.parse(
  } if (localStorage.getItem('user-info')) {
    return (
      <div>
        You Are Login
      </div>
    );
  } else {
    return (
      <>
      <Header backhref="#/"  />
      <div className="grid-x align-center">
      <div className="cell shrink">
        <div className="form-area-wrap padding-vertical-3">
          <div className="section-title margin-bottom-1">
            <h3>نسيت كلمة المرور </h3>
            <p>قم بادخال بريدك الالكتروني وسيصلك كلمة المرور الجديدة</p>
          </div>
          <div className="form-area">


          <div className="message alert text-center">
            {messagelog}
          </div>

            <div className="input-field">

              <span className="ico-label"><i className="icomoon-icon icon-envelop2"></i></span>
              <input type="email" required="required" name="email" placeholder="البريد الالكتروني" onChange={(e) => setEmail(e.target.value)} defaultValue={email}  />
            </div>



            <div className="text-center">
              <button onClick={login} className="button submit-btn" >ارسال</button>
              <div className="custom-txt-style"><span>أو</span></div>
              <div className="form-socials-btns">

               
                <Facebook samirCallback = {handleCheckChange} />
                <Google  />

              </div>

            </div>
          </div>
        </div>
        </div>
        </div>
</>
    );
  }


  
}

export default CheckEmail;
